import { CommonCarrierService } from '@savgroup-front-common/core/api';

import { cancelPackingCommand } from '@/api/Carrier/cancelPackingCommand';
import createPackingCommand from '@/api/Carrier/createPackingCommand';
import { deleteCarrierAccountCommand } from '@/api/Carrier/deleteCarrierAccountCommand';
import { getCarrierAccountsBySellerQuery } from '@/api/Carrier/getCarrierAccountsBySellerQuery';
import getCarrierDimensionSpecificationsQuery from '@/api/Carrier/getCarrierDimensionSpecificationsQuery';
import getCarrierLabelUrlByPackingParcelIdQuery from '@/api/Carrier/getCarrierLabelUrlByPackingParcelIdQuery';
import { getGenericCarrierAccountsQuery } from '@/api/Carrier/getGenericCarrierAccountsQuery';
import getPackingBySellerByStatusQuery from '@/api/Carrier/getPackingBySellerByStatusQuery';
import getWaitingPackingProductsBySellerQuery from '@/api/Carrier/getWaitingPackingProductsBySellerQuery';
import { retryPackingCommand } from '@/api/Carrier/retryPackingCommand';
import uploadExternalCarrierDepositLabelCommand from '@/api/Carrier/uploadExternalCarrierDepositLabelCommand';
import { upsertGenericCarrierAccountCommand } from '@/api/Carrier/upsertGenericCarrierAccountCommand';
import validatePackingCommand from '@/api/Carrier/validatePackingCommand';

import getFileLabelAddress from './getFileLabelAddress';
import getFileLabels from './getFileLabels';
import getFileShippingsQuery from './getFileShippingsQuery';
import getGenericCarrierAccountsDefinitionsQuery from './getGenericCarrierAccountsDefinitionsQuery';
import getGenericCarrierAccountsForUpsQuery from './getGenericCarrierAccountsForUpsQuery';
import getPricingForGenericCarrierAccountQuery from './getPricingForGenericCarrierAccountQuery';
import getShippingLabelQuery from './getShippingLabelQuery';
import listExternalCarrierCompanysQuery from './listExternalCarrierCompanysQuery';
import setDeleteAccountCarrier from './setDeleteAccountCarrier';
import setFileLabelAddress from './setFileLabelAddress';
import upsertGenericCarrierAccountForUpsCommand from './upsertGenericCarrierAccountForUpsCommand';
import upsertPricingForGenericCarrierAccountCommand from './upsertPricingForGenericCarrierAccountCommand';
import verifyAddress from './verifyAddress';

export const CarrierService = {
  getPickupPointByGeoCoordQuery:
    CommonCarrierService.getPickupPointByGeoCoordQuery,
  verifyAddress,
  getFileLabelAddress,
  getFileLabels,
  setFileLabelAddress,
  createHomePickupCommand: CommonCarrierService.createHomePickupCommand,
  getFileShippingsQuery,
  getGenericCarrierAccountsForUpsQuery,
  getGenericCarrierAccountsDefinitionsQuery,
  upsertGenericCarrierAccountForUpsCommand,
  getGenericCarrierAccountsQuery,
  upsertGenericCarrierAccountCommand,
  getCarrierAccountsBySellerQuery,
  deleteCarrierAccountCommand,
  listExternalCarrierCompanysQuery,
  getTransportPlanByIdQuery: CommonCarrierService.getTransportPlanByIdQuery,
  upsertPricingForGenericCarrierAccountCommand,
  getPricingForGenericCarrierAccountQuery,
  getShippingLabelQuery,
  setDeleteAccountCarrier,
  getWaitingPackingProductsBySellerQuery,
  getPackingBySellerByStatusQuery,
  getCarrierDimensionSpecificationsQuery,
  getCarrierLabelUrlByPackingParcelIdQuery,
  createPackingCommand,
  validatePackingCommand,
  retryPackingCommand,
  cancelPackingCommand,
  uploadExternalCarrierDepositLabelCommand,
};
